import useDoubleInput from "./useDoubleInput";

export default useDoubleInput;
